import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const RecentBookings = () => {
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortBy, setSortBy] = useState('date');

  const bookings = [
    {
      id: "BK-2025-001",
      customer: "Sarah Johnson",
      email: "sarah.j@email.com",
      phone: "(555) 123-4567",
      service: "Deep Cleaning",
      date: "2025-01-13",
      time: "09:00 AM",
      status: "confirmed",
      amount: 149.99,
      staff: "Mike Rodriguez",
      address: "123 Oak Street, Downtown"
    },
    {
      id: "BK-2025-002",
      customer: "Tech Solutions Inc",
      email: "admin@techsolutions.com",
      phone: "(555) 987-6543",
      service: "Office Cleaning",
      date: "2025-01-13",
      time: "01:30 PM",
      status: "pending",
      amount: 299.99,
      staff: "Lisa Chen",
      address: "456 Business Ave, Suite 200"
    },
    {
      id: "BK-2025-003",
      customer: "David Wilson",
      email: "david.wilson@email.com",
      phone: "(555) 456-7890",
      service: "Carpet Cleaning",
      date: "2025-01-13",
      time: "04:00 PM",
      status: "in-progress",
      amount: 89.99,
      staff: "Carlos Martinez",
      address: "789 Pine Road, Suburbs"
    },
    {
      id: "BK-2025-004",
      customer: "Emma Thompson",
      email: "emma.t@email.com",
      phone: "(555) 321-0987",
      service: "Post-Construction Cleaning",
      date: "2025-01-12",
      time: "10:00 AM",
      status: "completed",
      amount: 399.99,
      staff: "Mike Rodriguez",
      address: "321 New Construction Blvd"
    },
    {
      id: "BK-2025-005",
      customer: "Green Office Complex",
      email: "facilities@greenoffice.com",
      phone: "(555) 654-3210",
      service: "Commercial Disinfection",
      date: "2025-01-12",
      time: "06:00 PM",
      status: "cancelled",
      amount: 199.99,
      staff: "Lisa Chen",
      address: "555 Corporate Drive"
    }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'pending', label: 'Pending' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const sortOptions = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'customer', label: 'Sort by Customer' },
    { value: 'amount', label: 'Sort by Amount' },
    { value: 'status', label: 'Sort by Status' }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed':
        return 'bg-success/10 text-success border-success/20';
      case 'pending':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'in-progress':
        return 'bg-primary/10 text-primary border-primary/20';
      case 'completed':
        return 'bg-muted text-text-secondary border-border';
      case 'cancelled':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-muted text-text-secondary border-border';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'confirmed':
        return 'CheckCircle';
      case 'pending':
        return 'Clock';
      case 'in-progress':
        return 'Play';
      case 'completed':
        return 'Check';
      case 'cancelled':
        return 'X';
      default:
        return 'Circle';
    }
  };

  const filteredBookings = bookings?.filter(booking => 
    statusFilter === 'all' || booking?.status === statusFilter
  );

  const handleStatusUpdate = (bookingId, newStatus) => {
    console.log(`Updating booking ${bookingId} to ${newStatus}`);
    // Handle status update logic
  };

  const handleViewDetails = (booking) => {
    console.log('Viewing booking details:', booking);
    // Handle view details logic
  };

  const handleContactCustomer = (booking) => {
    console.log('Contacting customer:', booking?.customer);
    // Handle customer contact logic
  };

  return (
    <div className="bg-white rounded-lg border border-border">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between p-6 border-b border-border space-y-4 sm:space-y-0">
        <div>
          <h3 className="text-lg font-semibold text-text-primary">Recent Bookings</h3>
          <p className="text-sm text-text-secondary">Manage and track service bookings</p>
        </div>
        
        <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={setStatusFilter}
            className="w-full sm:w-40"
          />
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={setSortBy}
            className="w-full sm:w-40"
          />
          <Button variant="default" iconName="Plus" iconPosition="left">
            New Booking
          </Button>
        </div>
      </div>
      {/* Bookings Table */}
      <div className="overflow-x-auto">
        <div className="min-w-full">
          {/* Desktop Table Header */}
          <div className="hidden lg:grid lg:grid-cols-12 gap-4 p-4 bg-muted/50 border-b border-border text-sm font-medium text-text-secondary">
            <div className="col-span-2">Customer</div>
            <div className="col-span-2">Service</div>
            <div className="col-span-2">Date & Time</div>
            <div className="col-span-1">Amount</div>
            <div className="col-span-2">Status</div>
            <div className="col-span-1">Staff</div>
            <div className="col-span-2">Actions</div>
          </div>

          {/* Bookings List */}
          <div className="divide-y divide-border">
            {filteredBookings?.map((booking) => (
              <div key={booking?.id} className="p-4 hover:bg-muted/30 transition-colors duration-200">
                {/* Desktop Layout */}
                <div className="hidden lg:grid lg:grid-cols-12 gap-4 items-center">
                  <div className="col-span-2">
                    <div className="font-medium text-text-primary">{booking?.customer}</div>
                    <div className="text-sm text-text-secondary">{booking?.email}</div>
                    <div className="text-sm text-text-secondary">{booking?.phone}</div>
                  </div>
                  
                  <div className="col-span-2">
                    <div className="font-medium text-text-primary">{booking?.service}</div>
                    <div className="text-sm text-text-secondary truncate">{booking?.address}</div>
                  </div>
                  
                  <div className="col-span-2">
                    <div className="font-medium text-text-primary">{booking?.date}</div>
                    <div className="text-sm text-text-secondary">{booking?.time}</div>
                  </div>
                  
                  <div className="col-span-1">
                    <div className="font-semibold text-text-primary font-mono">${booking?.amount}</div>
                  </div>
                  
                  <div className="col-span-2">
                    <div className={`inline-flex items-center space-x-2 px-3 py-1 rounded-full border text-xs font-medium ${getStatusColor(booking?.status)}`}>
                      <Icon name={getStatusIcon(booking?.status)} size={12} />
                      <span className="capitalize">{booking?.status?.replace('-', ' ')}</span>
                    </div>
                  </div>
                  
                  <div className="col-span-1">
                    <div className="text-sm text-text-primary">{booking?.staff}</div>
                  </div>
                  
                  <div className="col-span-2">
                    <div className="flex items-center space-x-2">
                      <Button
                        variant="outline"
                        size="sm"
                        iconName="Eye"
                        iconPosition="left"
                        onClick={() => handleViewDetails(booking)}
                      >
                        View
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleContactCustomer(booking)}
                      >
                        <Icon name="Phone" size={16} />
                      </Button>
                      <Button variant="ghost" size="icon">
                        <Icon name="MoreVertical" size={16} />
                      </Button>
                    </div>
                  </div>
                </div>

                {/* Mobile Layout */}
                <div className="lg:hidden space-y-3">
                  <div className="flex items-start justify-between">
                    <div>
                      <h4 className="font-medium text-text-primary">{booking?.customer}</h4>
                      <p className="text-sm text-text-secondary">{booking?.service}</p>
                      <p className="text-xs text-text-secondary">{booking?.id}</p>
                    </div>
                    <div className={`flex items-center space-x-1 px-2 py-1 rounded-full border text-xs font-medium ${getStatusColor(booking?.status)}`}>
                      <Icon name={getStatusIcon(booking?.status)} size={10} />
                      <span className="capitalize">{booking?.status?.replace('-', ' ')}</span>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between text-sm">
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center space-x-1">
                        <Icon name="Calendar" size={14} />
                        <span>{booking?.date}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Clock" size={14} />
                        <span>{booking?.time}</span>
                      </div>
                    </div>
                    <div className="font-semibold text-text-primary font-mono">${booking?.amount}</div>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-1 text-sm text-text-secondary">
                      <Icon name="User" size={14} />
                      <span>{booking?.staff}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Button
                        variant="outline"
                        size="sm"
                        iconName="Eye"
                        onClick={() => handleViewDetails(booking)}
                      />
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleContactCustomer(booking)}
                      >
                        <Icon name="Phone" size={16} />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Footer */}
      <div className="flex items-center justify-between p-4 border-t border-border">
        <div className="text-sm text-text-secondary">
          Showing {filteredBookings?.length} of {bookings?.length} bookings
        </div>
        <div className="flex items-center space-x-2">
          <Button variant="outline" size="sm" disabled>
            <Icon name="ChevronLeft" size={16} />
          </Button>
          <span className="text-sm text-text-primary">Page 1 of 1</span>
          <Button variant="outline" size="sm" disabled>
            <Icon name="ChevronRight" size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RecentBookings;